import { PhotoData } from "../../photo/interfaces/dto";

export default function resizePopupPhotoWrapper(
	popup: HTMLElement,
	photoData: PhotoData,
) {
	const { findHtmlEl } = pm.utils.dom;

	const popupPhotoWrapper = findHtmlEl(popup, ".single-image-wrapper");
	if (!popupPhotoWrapper) return;

	// const popupPhotoWrapperHeight = popupPhotoWrapper
	// 	? getPureInnerHeight(popupPhotoWrapper)
	// 	: 0;

	const isVideo = photoData.videoUrl ? true : false;
	const popupPhoto = findHtmlEl(popup, ".single-image");

	if (isVideo) {
		if (popupPhoto) {
			const iframeWidth = popupPhoto.clientWidth;
			// Calculate using 16:9 ratio.
			const iframeHeight = iframeWidth * 0.5625;
			popupPhoto.style.height = iframeHeight + "px";

			popupPhotoWrapper.classList.add("height-auto");
			popupPhotoWrapper.style.width = iframeWidth + "px";
		}
	} else {
		const photoWidth = photoData.width;
		const photoHeight = photoData.height;

		const popupPhotoWrapperHeight = window.innerHeight - 270;
		const heightRatio = popupPhotoWrapperHeight / photoHeight;
		const calculatedPopupPhotoWrapperWidth = Math.round(
			photoWidth * heightRatio,
		);

		if (photoWidth >= photoHeight) {
			popupPhotoWrapper.style.width = calculatedPopupPhotoWrapperWidth + "px";
			popupPhotoWrapper.classList.add("height-auto");

			if (popupPhoto && !isVideo) {
				popupPhoto.style.height = "auto";
			}
		} else {
			popupPhotoWrapper.style.width = "auto";

			const renderedPopupPhotoWrapperWidth = popupPhotoWrapper.clientWidth;

			if (renderedPopupPhotoWrapperWidth < calculatedPopupPhotoWrapperWidth) {
				popupPhotoWrapper.style.width = renderedPopupPhotoWrapperWidth + "px";
				popupPhotoWrapper.classList.add("height-auto");
			} else {
				popupPhotoWrapper.style.width = calculatedPopupPhotoWrapperWidth + "px";
				popupPhotoWrapper.classList.remove("height-auto");
			}
		}
	}
}
